import SpitialSubscription from "../../components/subscription/wrapper";
import RootLayout from "../layout";
const SubscriptionPage = () => {
  return (
    <RootLayout>
      <SpitialSubscription />
    </RootLayout>
  );
};
export default SubscriptionPage;
